import React from 'react';
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {Button} from "antd";
import {Link} from "react-router-dom";
import {ExternalLink} from "lucide-react";


function NotificationButton({notification}) {

    let url = null;

    switch (notification.type) {
        case 'StudentNewHomeworkAlertNotification':
            if (notification?.data?.lesson_id && notification?.data?.homework_id) {
                url = sprintf(URLS.student.lessons.myLesson.homework, {
                    id: notification?.data?.lesson_id,
                    homeworkId: notification?.data?.homework_id
                });
            }
            break;

    }

    if (url) {
        return (<Link to={url}>
            <Button
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed`}>
                <ExternalLink className={'w-4 h-4'}/>
                <span>نمایش</span>
            </Button>
        </Link>)
    }
    return null;
}

export default NotificationButton;